import { initialStateByModule } from './state'
import { setPromoCode, calculatePromoCode } from '@/api/services'
import { calcPromoCodeValue } from '@/utils/promoCode'
import { filter, get, head } from 'lodash'

const state = initialStateByModule('promoCode')

const CHANGE_PROMO_CODE_COMMISSION = 'changePromoCodeCommission'
const CHANGE_PROMO_CODE_ASYNC_PENDING = 'changePromoCodeAsyncPending'
const CHANGE_PROMO_CODE_VALID = 'changePromoCodeValid'
const CHANGE_PROMO_CODE_ACTIVATED = 'changePromoCodeActivated'

const mutations = {
  [CHANGE_PROMO_CODE_COMMISSION] (state, payload) {
    state.commission = payload
  },
  [CHANGE_PROMO_CODE_ASYNC_PENDING] (state, payload) {
    state.asyncPending = payload
  },
  [CHANGE_PROMO_CODE_VALID] (state, payload) {
    state.valid = payload
  },
  [CHANGE_PROMO_CODE_ACTIVATED] (state, payload) {
    state.activated = payload
  }
}

const actions = {
  [CHANGE_PROMO_CODE_ACTIVATED]: ({ commit }, payload) => {
    commit(CHANGE_PROMO_CODE_VALID, payload.valid)
    commit(CHANGE_PROMO_CODE_ACTIVATED, payload.activated)
  },
  [CHANGE_PROMO_CODE_COMMISSION]: ({ commit, dispatch, rootState, rootGetters }) => {
    if (!rootState.plan.promoCode.code) {
      commit(CHANGE_PROMO_CODE_COMMISSION, null)
      return
    }

    commit(CHANGE_PROMO_CODE_ASYNC_PENDING, true)

    if (rootState.product.alias !== 'residencial') {
      const bin = rootGetters['payment/bin']
      calculatePromoCode({
        bin,
        amount: rootState.plan.preco,
        planUuid: rootState.plan.uuid,
        product: rootState.product.aliasEN,
        promocode: rootState.plan.promoCode.code
      })
        .then(res => {
          if (res.status !== 200) {
            commit(CHANGE_PROMO_CODE_VALID, false)
            commit(CHANGE_PROMO_CODE_COMMISSION, null)
            commit(CHANGE_PROMO_CODE_ASYNC_PENDING, false)
            document.getElementById('code').focus()
            return
          }

          dispatch('lead/patchLeadAction', {
            promocode: rootState.plan.promoCode.code
          }, { root: true })

          commit(CHANGE_PROMO_CODE_ACTIVATED, true)
          commit(CHANGE_PROMO_CODE_VALID, true)

          const data = {
            applied: state.activated,
            completePrice: res.data.requestValueWithPromocode
          }

          dispatch('plan/changePlanPromoCodeApplied', data, { root: true })

          commit(CHANGE_PROMO_CODE_ASYNC_PENDING, false)
        })
        .catch(error => {
          commit(CHANGE_PROMO_CODE_VALID, false)
          commit(CHANGE_PROMO_CODE_COMMISSION, null)
          commit(CHANGE_PROMO_CODE_ASYNC_PENDING, false)

          document.getElementById('code').focus()

          console.debug('[PromoCode] - calculatePromoCode', error)
        })
    } else {
      setPromoCode({
        apiPath: rootState.product.api,
        data: rootState.plan.promoCode.code
      })
        .then(res => {
          if (res.data.error) {
            throw new Error('[PromoCode] - setPromoCode', res.data.error)
          }

          const promoValue = get(head(filter(res.data.result.products, product => product.code === 'residencial')), ['value'])
          if (!promoValue) {
            commit(CHANGE_PROMO_CODE_VALID, false)
            commit(CHANGE_PROMO_CODE_COMMISSION, null)
            commit(CHANGE_PROMO_CODE_ASYNC_PENDING, false)
            document.getElementById('code').focus()
            return
          }

          commit(CHANGE_PROMO_CODE_ACTIVATED, true)
          commit(CHANGE_PROMO_CODE_VALID, true)

          let discountType = ''

          switch (res.data.result.discountType) {
            case 'commission':
              discountType = CHANGE_PROMO_CODE_COMMISSION
              break
            default:
          }

          commit(discountType, promoValue)

          const data = {
            applied: state.activated,
            completePrice: calcPromoCodeValue()
          }

          dispatch('plan/changePlanPromoCodeApplied', data, { root: true })

          commit(CHANGE_PROMO_CODE_ASYNC_PENDING, false)
        })
        .catch(error => {
          commit(CHANGE_PROMO_CODE_VALID, false)
          commit(CHANGE_PROMO_CODE_COMMISSION, null)
          commit(CHANGE_PROMO_CODE_ASYNC_PENDING, false)

          document.getElementById('code').focus()

          console.debug('[PromoCode] - setPromoCode', error)
        })
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
